<script>
import axios from "axios";
import Qs from "qs";
import * as qiniu from "qiniu-js";
import {
  K_DOMAIN,
  K_DOWNLOAD,
  K_QINIU_IMAGE_SMALL_END_200_SUFFIX,
  K_QINIU_IMAGE_SMALL_END_100_PX_SUFFIX,
  K_VERSION,
  K_PROJECT_NAME
} from "../../public/static/js/config";
import storage from "../../public/static/js/storage";
const domain = K_DOMAIN;
const download = K_DOWNLOAD;

const K_QINIU_IMAGE_SMALL_END_200 = K_QINIU_IMAGE_SMALL_END_200_SUFFIX;
const K_QINIU_IMAGE_SMALL_END_100_PX = K_QINIU_IMAGE_SMALL_END_100_PX_SUFFIX;

let token = "";
let language = "";

function getHttpConfigs() {
  let configs = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Authorization: getToken(),
      "Accept-Language": "en"
    }
  };
  return configs;
}

/*
 * config.useCdnDomain: 是否使用 cdn 加速域名，true or false，默认为 false。
 * config.disableStatisticsReport: 是否禁用日志报告，为布尔值，默认为false。
 * config.region: 选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域
 * config.retryCount: 上传自动重试次数（整体重试次数）；默认3次（即上传失败后最多重试两次）；
 * config.concurrentRequestLimit: 分片上传的并发请求量，number，默认为3；
 * config.checkByMD5: 是否开启 MD5 校验，在断点续传时校验分片，默认为 false，不开启。
 */
let qiniu_configs = {
  useCdnDomain: true,
  region: qiniu.region.na0
};

function getFileConfigs() {
  let fileConfigs = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  };
  return fileConfigs;
}

function loggedIn() {
  return getToken() != null && getToken() != "";
}

function getAuthority() {
  return JSON.parse(sessionStorage.getItem("_user"));
}

Date.prototype.Format = function(fmt, local, utc) {
  let tempTime = this;
  let o = {};
  if (utc) {
    o = {
      "y+": tempTime.getUTCFullYear(),
      "M+": tempTime.getUTCMonth() + 1, //月份
      "d+": tempTime.getUTCDate(), //日
      "h+": tempTime.getUTCHours(), //小时
      "m+": tempTime.getUTCMinutes(), //分
      "s+": tempTime.getUTCSeconds(), //秒
      "q+": Math.floor((tempTime.getUTCMonth() + 3) / 3), //季度
      "S+": tempTime.getMilliseconds() //毫秒
    };
  } else {
    o = {
      "y+": tempTime.getFullYear(),
      "M+": tempTime.getMonth() + 1, //月份
      "d+": tempTime.getDate(), //日
      "h+": tempTime.getHours(), //小时
      "m+": tempTime.getMinutes(), //分
      "s+": tempTime.getSeconds(), //秒
      "q+": Math.floor((tempTime.getMonth() + 3) / 3), //季度
      "S+": tempTime.getMilliseconds() //毫秒
    };
  }

  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      if (k == "y+") {
        fmt = fmt.replace(RegExp.$1, ("" + o[k]).substr(4 - RegExp.$1.length));
      } else if (k == "S+") {
        var lens = RegExp.$1.length;
        lens = lens == 1 ? 3 : lens;
        fmt = fmt.replace(
          RegExp.$1,
          ("00" + o[k]).substr(("" + o[k]).length - 1, lens)
        );
      } else {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
  }
  if (local) {
    //获取时区
    let timeOff = new Date().getTimezoneOffset() / 60;
    let sign = Math.sign(timeOff);
    let zone = ("00" + Math.abs(timeOff) + "00").substr(
      ("" + Math.abs(timeOff)).length
    );
    zone = sign === -1 ? "+" + zone.toString() : "-" + zone.toString();
    fmt = fmt + " " + zone;
  }
  return fmt;
};

function toggleLoader(type) {
  document.getElementById("loader-overlay").style.display = type
    ? "block"
    : "none";
}

function httpGet(url, params) {
  let paramsString = params ? requestParams(params) : "";
  return new Promise((resolve, reject) => {
    axios.get(domain + url + paramsString, getHttpConfigs()).then(
      res => {
        resolve(res.data);
      },
      err => {
        reject(err.response.data);
      }
    );
  });
}

function httpPost(url, params) {
  // 访问网络
  return new Promise((resolve, reject) => {
    axios({
      headers: getHttpConfigs().headers,
      method: "post",
      url: domain + url,
      data: Qs.stringify(params, { arrayFormat: "repeat" })
    }).then(
      res => {
        resolve(res.data);
      },
      err => {
        reject(err.response.data);
      }
    );
  });
}
function httpPostBlob(url, params) {
  // 访问网络
  return new Promise((resolve, reject) => {
    axios({
      responseType: "blob",
      headers: getHttpConfigs().headers,
      method: "post",
      url: domain + url,
      data: Qs.stringify(params, { arrayFormat: "repeat" })
    }).then(
      res => {
        // resolve(res.data);
        resolve(res);
      },
      err => {
        reject(err.response.data);
      }
    );
  });
}

function httpFilePost(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(domain + url, data, getFileConfigs()).then(
      res => {
        resolve(res.data);
      },
      err => {
        reject(err.response.data);
      }
    );
  });
}

function requestParams(obj) {
  let rangeArr = [],
    params = "";
  if (obj && typeof obj === "object") {
    if (rangeArr.length != 0) {
      rangeArr.push("?");
    }
    for (let i in obj) {
      if (obj.hasOwnProperty(i)) {
        let value = obj[i];
        if (Object.prototype.toString.call(value) === "[object Array]") {
          if (value !== []) {
            for (let j in value) {
              rangeArr.push(i);
              rangeArr.push("=");
              rangeArr.push(value[j]);
              rangeArr.push("&");
            }
          }
        } else {
          if (value !== "") {
            rangeArr.push(i);
            rangeArr.push("=");
            rangeArr.push(value);
            rangeArr.push("&");
          }
        }
      }
    }
    params = rangeArr.join("").replace(/&$/, "");
    return params;
  }
}

function isEmailAvailable(emailInput) {
  let email_reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  return email_reg.test(emailInput);
}
// 时间转为字符串加上时区
function formatTimestampLongZone(time) {
  let timestamp = new Date(time).getTime() / 1000;
  if (timestamp > 0) {
    let date = new Date(timestamp * 1000);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    let HH =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    let MM =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    let SS =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    //获取时区
    let timeOff = new Date().getTimezoneOffset() / 60;
    let sign = Math.sign(timeOff);
    let zone = ("00" + Math.abs(timeOff) + "00").substr(
      ("" + Math.abs(timeOff)).length
    );
    zone = sign === -1 ? "+" + zone.toString() : "-" + zone.toString();
    // fmt = fmt + ' ' + zone;

    return Y + M + D + " " + HH + MM + SS + " " + zone;
  } else {
    return "";
  }
}
// 时间戳转字符串时间
function formatTimestamp(timestamp) {
  if (timestamp > 0) {
    let date = new Date(timestamp * 1000);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  } else {
    return "";
  }
}

// 时间戳转字符串时间
function formatTimestampLong(timestamp) {
  if (timestamp > 0) {
    let date = new Date(timestamp * 1000);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    let HH =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    let MM =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    let SS =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    return Y + M + D + " " + HH + MM + SS;
  } else {
    return "";
  }
}

// 时间格式处理
function formatTimesToTime(time) {
  let timestamp = new Date(time).getTime() / 1000;
  if (timestamp > 0) {
    let date = new Date(timestamp * 1000);
    let Y = date.getFullYear() + "-";
    let M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    let HH =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    let MM =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    let SS =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    return Y + M + D + " " + HH + MM + SS;
  } else {
    return "";
  }
}

// 时间转时间戳 delay 直接记为秒
function formatTime(time, delay) {
  let timestamp = new Date(time).getTime() / 1000;
  if (delay) {
    timestamp = timestamp + delay;
  }
  return String(timestamp) + ".000";
}

/**
 * 使用循环的方式判断一个元素是否存在于一个数组中
 * @param {Object} arr 数组
 * @param {Object} value 元素值
 */
function isInArray(arr, value) {
  for (let i = 0; i < arr.length; i++) {
    if (value === arr[i]) {
      return { isIn: true, index: i };
    }
  }
  return { isIn: false, index: 0 };
}

/**
 * 删除数组中的元素
 * @param {Object} arr 数组
 * @param {Object} value 元素值
 * */
function delInArray(value, arr) {
  let index = arr.indexOf(value);
  arr.splice(index, 1);
  return arr;
}

function getUserInfoCookie() {
  let userJson = sessionStorage.getItem("_user");
  if (userJson !== null && userJson.length > 0) {
    let userInfo = JSON.parse(userJson);
    return userInfo;
  } else {
    return null;
  }
}

function saveUserInfoCookie(userInfo) {
  let userJson = JSON.stringify(userInfo);
  // 存储用户信息
  sessionStorage.setItem("_user", userJson);
}

function setToken(newToken) {
  token = newToken;
}

function getToken() {
  if (token == null || token == "") {
    token = sessionStorage.getItem("_token");
  }
  return token;
}
function isNumber(value) {
  return !Number.isNaN(Number(value));
}

/* ------ 七牛上传图片 ---------------------------------------------------------------------------- */
function qiniuUploadImage(file, key, progress, callback) {
  // 获取Key
  let params = {};
  httpPost("/api/qiniu/get/token", params)
    .then(res => {
      if (res.code === "1000000") {
        let qiniu_key = res.data;
        let putExtra = {
          fname: file.name,
          params: {}
          // mimeType: ["image/png", "image/jpeg", "image/gif"]
        };
        let observe = {
          // eslint-disable-next-line no-unused-vars
          next(res) {
            // console.log('已上传大小，单位为字节：' + res.total.loaded)
            // console.log('本次上传的总量控制信息，单位为字节：' + res.total.size)
            // console.log('当前上传进度，范围：0～100：' + res.total.percent);
            progress(res);
          },
          error(err) {
            // console.log(err.code)
            // console.log(err.message)
            // console.log(err.isRequestError)
            // console.log(err.reqId)
            callback(err.message, err);
          },
          complete(res) {
            //完成后的操作
            //上传成功以后会返回key 和 hash  key就是文件名了！
            callback(undefined, res);
          }
        };
        //开始上传  token 需要找后端获取(单独的方法)
        let observable = qiniu.upload(
          file,
          key,
          qiniu_key,
          putExtra,
          qiniu_configs
        );
        // eslint-disable-next-line
        let subscription = observable.subscribe(observe);
      } else {
        callback(res.message, undefined);
      }
    })
    .catch(err => {
      // console.log("获取Token出现错误", err)
      callback(err, undefined);
    });
}

/* ------ 七牛上传列表 ---------------------------------------------------------------------------- */

function getFileObjURL(file) {
  //获取图片路径
  let url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}
// 获取国家地区列表
function get_address_list() {
  // this.loading = true;
  let params = {};
  httpGet("/api/address/find/list", params)
    .then(res => {
      if (res.code == "1000000") {
        sessionStorage.setItem("address_info", JSON.stringify(res.data));
      }
    })
    .catch(err => {});
  return JSON.parse(sessionStorage.getItem("address_info"));
}
function get_address_list_info() {
  if (sessionStorage.getItem("address_info")) {
    return JSON.parse(sessionStorage.getItem("address_info"));
  } else {
    get_address_list();
  }
}
// 创建一个公共存储方法
function get_storage_list(storage_params, transmit_way, url) {
  let storage_list = JSON.parse(sessionStorage.getItem(storage_params));
  return new Promise((resolve, reject) => {
    let params = {};
    // 如果本地没有对应存储而且请求方式是get时
    if (!storage_list && transmit_way == "http_get") {
      httpGet(url, params)
        .then(res => {
          if ((res.code = 1000000) && res) {
            storage_list = res.data;
            sessionStorage.setItem(storage_params, JSON.stringify(res.data));
          }
          resolve(storage_list);
        })
        .catch(err => {
          console.log(err);
        });
      // 如果本地没有对应存储而且请求方式是post时
    } else if (!storage_list && transmit_way == "http_post") {
      httpPost(url, params)
        .then(res => {
          if ((res.code = 1000000) && res) {
            storage_list = res.data;
            sessionStorage.setItem(storage_params, JSON.stringify(res.data));
          }
          resolve(storage_list);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      resolve(storage_list);
    }
  });
}
function get_country_list() {
  let params = {};
  httpGet("/api/address/country/find/list", params)
    .then(res => {
      if (res.code == "1000000") {
        sessionStorage.setItem("country_list", JSON.stringify(res.data));
      }
    })
    .catch(err => {});
  return JSON.parse(sessionStorage.getItem("country_list"));
}
function get_country_list_info() {
  if (sessionStorage.getItem("country_list")) {
    return JSON.parse(sessionStorage.getItem("country_list"));
  } else {
    get_country_list();
  }
}
// 获取省份列表并存储
function get_province_list() {
  let params = {};
  httpPost("/api/address/province/find/list", params)
    .then(res => {
      if (res.code == "1000000") {
        sessionStorage.setItem("province_list", JSON.stringify(res.data));
      }
    })
    .catch(err => {});
  return JSON.parse(sessionStorage.getItem("province_list"));
}
function get_province_list_info() {
  if (sessionStorage.getItem("province_list")) {
    return JSON.parse(sessionStorage.getItem("province_list"));
  } else {
    get_province_list();
  }
}

// 获取城市列表并存储
function get_city_list() {
  let params = {};
  httpPost("/api/address/city/find/list", params)
    .then(res => {
      // _me.loading = false;
      if (res.code == "1000000") {
        sessionStorage.setItem("city_list", JSON.stringify(res.data));
      }
    })
    .catch(err => {});
  return JSON.parse(sessionStorage.getItem("city_list"));
}
function get_city_list_info() {
  if (sessionStorage.getItem("city_list")) {
    return JSON.parse(sessionStorage.getItem("city_list"));
  } else {
    get_city_list();
  }
}

// 利用映射国家id获取对应的信息
function get_country_related_info(id) {
  let country_list = sessionStorage.getItem("country_list");
  let country_list_map = new Map();
  JSON.parse(country_list).forEach((item, index) => {
    country_list_map.set(item.id, item);
  });
  if (id) {
    return country_list_map.get(id);
  }
}
// 利用映射省份id获取对应的信息
function get_province_related_info(id) {
  let province_list = sessionStorage.getItem("province_list");
  let province_list_map = new Map();
  JSON.parse(province_list).forEach((item, index) => {
    province_list_map.set(item.id, item);
  });
  if (id) {
    return province_list_map.get(id);
  }
}
// 利用映射城市id获取对应的信息
function get_city_related_info(id) {
  let city_list = sessionStorage.getItem("city_list");
  let city_list_map = new Map();
  JSON.parse(city_list).forEach((item, index) => {
    city_list_map.set(item.id, item);
  });
  if (id) {
    return city_list_map.get(id);
  }
}

// 利用映射将零售id转换成对应的零售名字
function get_retail_area_name(id) {
  let retail_area_type_list = sessionStorage.getItem("retail_area_type_list");
  let retail_area_type_list_map = new Map();
  JSON.parse(retail_area_type_list).forEach((item, index) => {
    retail_area_type_list_map.set(item.id, item.name);
  });
  if (id) {
    return retail_area_type_list_map.get(id);
  }
}
// 获取评分标准列表
function get_score_stard_list() {
  let params = {};
  httpGet("/api/grade/admin/find/list", params)
    .then(res => {
      if (res.code == "1000000") {
        sessionStorage.setItem("score_stard_list", JSON.stringify(res.data));
      }
    })
    .catch(err => {});
  return JSON.parse(sessionStorage.getItem("score_stard_list"));
}
function get_score_stard_list_info() {
  if (sessionStorage.getItem("score_stard_list")) {
    return JSON.parse(sessionStorage.getItem("score_stard_list"));
  } else {
    get_score_stard_list();
  }
}
// 获取零售区类型列表
function get_retail_area_type_list() {
  let params = {};
  httpGet("/api/store/admin/retail/area/type/find/list", params)
    .then(res => {
      if (res.code == "1000000") {
        sessionStorage.setItem(
          "retail_area_type_list",
          JSON.stringify(res.data)
        );
      }
    })
    .catch(err => {});
  return JSON.parse(sessionStorage.getItem("retail_area_type_list"));
}
function get_retail_area_type_list_info() {
  if (sessionStorage.getItem("retail_area_type_list")) {
    return JSON.parse(sessionStorage.getItem("retail_area_type_list"));
  } else {
    get_retail_area_type_list();
  }
}
//深拷贝
function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function tableStyle() {
  return "text-align:center";
}

let globalStorage = storage;

function setGlobalStorage(key, value, expired) {
  if (value && value !== undefined) {
    return globalStorage.set(getGlobalStorageKeyName(key), value, expired);
  }
}

function getGlobalStorage(key) {
  return globalStorage.get(getGlobalStorageKeyName(key));
}

function removeGlobalStorage(key) {
  return globalStorage.remove(getGlobalStorageKeyName(key));
}

function getGlobalStorageKeyName(key) {
  //  项目 + 版本号 + key
  return K_PROJECT_NAME + "::" + K_VERSION + "::" + key;
}

// 复制信息方法
function copyText(text) {
  let textarea = document.createElement("input"); //创建input对象
  let currentFocus = document.activeElement; //当前获得焦点的元素
  document.body.appendChild(textarea); //添加元素
  textarea.value = text;
  textarea.focus();
  if (textarea.setSelectionRange) {
    textarea.setSelectionRange(0, textarea.value.length); //获取光标起始位置到结束位置
  } else {
    textarea.select();
  }

  let flag = false;
  try {
    flag = document.execCommand("copy"); //执行复制
  } catch (eo) {
    flag = false;
  }
  document.body.removeChild(textarea); //删除元素
  currentFocus.focus();
  return flag;
}
export default {
  getHttpConfigs,
  download,
  K_QINIU_IMAGE_SMALL_END_200,
  K_QINIU_IMAGE_SMALL_END_100_PX,
  httpPost,
  httpFilePost,
  httpPostBlob,
  toggleLoader,
  isEmailAvailable,
  loggedIn,
  getToken,
  setToken,
  formatTimestampLongZone,
  formatTimestamp,
  formatTimestampLong,
  formatTimesToTime,
  formatTime,
  isNumber,
  isInArray,
  delInArray,
  getUserInfoCookie,
  saveUserInfoCookie,
  getAuthority,
  qiniuUploadImage,
  getFileObjURL,
  httpGet,
  get_address_list,
  get_address_list_info,
  get_country_list,
  get_country_list_info,
  get_province_list,
  get_province_list_info,
  get_city_list,
  get_city_list_info,
  get_score_stard_list,
  get_score_stard_list_info,
  get_retail_area_type_list,
  get_retail_area_type_list_info,
  get_retail_area_name,
  get_storage_list,
  get_country_related_info,
  get_province_related_info,
  get_city_related_info,
  deepClone,
  tableStyle,
  setGlobalStorage,
  getGlobalStorage,
  removeGlobalStorage,
  getGlobalStorageKeyName,
  copyText
};
</script>
